export const config = {
  statusProjectsVariant: {
    inbox: 'dark',
    to_do: 'danger',
    complete: 'success',
    in_progress: 'warning',
  },
  statusProjectsText: {
    inbox: 'En espera',
    to_do: 'Pendiente',
    complete: 'Completado',
    in_progress: 'En proceso',
  },
  statusJobsVariants: {
    in_progress: 'warning',
    pending: 'danger',
    to_do: 'danger',
    inbox: 'info',
    complete: 'success',
    incidence: 'danger',
  },
  statusJobsText: {
    in_progress: 'En proceso',
    pending: 'Pendiente',
    to_do: 'Pendiente',
    inbox: 'En espera',
    complete: 'Completado',
    incidence: 'Incidencia',
  },
  statusTasksVariants: {
    in_progress: 'warning',
    pending: 'info',
    incidence: 'danger',
    complete: 'success',
  },
  statusTasksText: {
    in_progress: 'En proceso',
    pending: 'Pendiente',
    incidence: 'Incidencia',
    complete: 'Completado',
  },
  statusJourneyDayVariants: {
    in_progress: 'warning',
    pending: 'info',
    incidence: 'danger',
    complete: 'success',
    incomplete: 'danger',
  },
  statusJourneyDayText: {
    in_progress: 'En proceso',
    pending: 'Pendiente',
    incidence: 'Incidencia',
    complete: 'Completado',
    incomplete: 'Incompleto',
  },
  nameApp: 'Shireo',
  webApiBase: process.env.VUE_APP_ROOT_API,
  placeholder: process.env.VUE_APP_IMAGE_PLACEHOLDER,
  placeholderDocuments: process.env.VUE_APP_IMAGE_PLACEHOLDER_DOCUMENTS,
}
